import classNames from 'classnames';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { range } from 'lodash-es';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const ButtonSkeleton: FC<{ className: string; width: string }> = ({ className, width }) => (
  <button type="button" disabled className={classNames('btn btn-xl mb-2', className)}>
    <Skeleton width={width} className="text-primary" />
  </button>
);

export const ButtonPanelSkeleton: FC = () => {
  const isInternal = useIsInternalUser();
  const buttonCount = isInternal ? 3 : 1;
  return (
    <div className="d-flex flex-column align-items-stretch w-100 mx-0">
      {range(0, buttonCount).map(i => (
        <ButtonSkeleton width="5em" className="btn-primary" key={i} />
      ))}
      <ButtonSkeleton width="10em" className="btn-discreet-secondary" />
    </div>
  );
};
